// extracted by mini-css-extract-plugin
export var AlignCenter = "SubNav-module--AlignCenter--30d7a";
export var PageWrapper = "SubNav-module--PageWrapper--226af";
export var SpaceBetween = "SubNav-module--SpaceBetween--3c9bb";
export var Wrapper = "SubNav-module--Wrapper--f4b61";